export class Solver {
  constructor(boardList) {
    this.memory = [];
    this.boardList = boardList;
  }

  solve() {
    this.recursivelyCheck(0, 0);
    return this.getBoard();
  }

  getBoard() {
    return this.boardList;
  }

  cloneBoard() {
    return Object.assign(
      [],
      this.boardList.map((row) => Object.assign([], row)),
    );
  }

  recursivelyCheck(r, c) {
    while (r >= 0 && c >= 0 && r <= 8 && this.boardList[r][c] !== "") {
      if (c < 9) c++;
      else {
        r++;
        c = 0;
      }
    }
    if (c > 8) {
      r++;
      c = 0;
    }
    if (r > 8) return true;
    for (let n = 1; n < 10; n++) {
      let num = String(n);
      if (this.doesNotBreakBoard(r, c, num)) {
        this.boardList[r][c] = num;
        let tempBoard = this.cloneBoard();
        this.memory.push(tempBoard);
        if (this.recursivelyCheck(r, c + 1)) {
          return true;
        } else {
          this.boardList[r][c] = "";
          let tempBoard = this.cloneBoard();
          this.memory.push(tempBoard);
        }
      }
    }
    return false;
  }

  isValid() {
    let res = true;
    for (let row = 0; row < this.boardList.length; row++) {
      for (let col = 0; col < this.boardList[row].length; col++) {
        if (this.boardList[row][col] !== "") {
          if (this.boardList[row][col] === 0) return false;
          res = res && this.isSingle(row, col, this.boardList[row][col]);
        }
      }
    }
    return res;
  }

  isSingle(r, c, num) {
    let rStart, cStart;
    if (r <= 2) rStart = 0;
    else if (r <= 5) rStart = 3;
    else rStart = 6;

    if (c <= 2) cStart = 0;
    else if (c <= 5) cStart = 3;
    else cStart = 6;

    let subRow = 0;
    for (let i = 0; i < 9; i++) {
      if (this.boardList[r][i] === num && c !== i) return false;
      if (this.boardList[i][c] === num && r !== i) return false;
      let offset = i % 3;
      if (offset === 0 && i !== 0) subRow++;
      if (
        this.boardList[subRow + rStart][offset + cStart] === num &&
        subRow + rStart !== r &&
        offset + cStart !== c
      )
        return false;
    }
    return true;
  }

  doesNotBreakBoard(r, c, num) {
    let rStart, cStart;
    if (r <= 2) rStart = 0;
    else if (r <= 5) rStart = 3;
    else rStart = 6;

    if (c <= 2) cStart = 0;
    else if (c <= 5) cStart = 3;
    else cStart = 6;

    let subRow = 0;
    for (let i = 0; i < 9; i++) {
      if (this.boardList[r][i] === num) return false;
      if (this.boardList[i][c] === num) return false;
      let offset = i % 3;
      if (offset === 0 && i !== 0) subRow++;
      if (this.boardList[subRow + rStart][offset + cStart] === num)
        return false;
    }
    return true;
  }

  getMemory() {
    return this.memory;
  }
}
